import React from 'react';
import styled, { css } from 'styled-components';
import { Inline } from '@pleo-io/telescope-layout';
import { focusRing } from '@pleo-io/telescope-focus-ring';
import { fontDefault } from '@pleo-io/telescope-global-style';
import { Loading } from '@pleo-io/telescope-loading';
import { fontMedium, smooth, pink800, pink600, spacing8, spacing32, lineHeight1, circle, arc99999, shade500, shade300, shade400, shade000, shade800, shade900, shade600, shade700, shade200, shadowElevateStrong, shade100 } from '@pleo-io/telescope-tokens';

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  strings.raw = raw;
  return strings;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n    color: ", ";\n\n    &:visited {\n        color: ", ";\n    }\n\n    &:hover,\n    &:active {\n        color: ", ";\n    }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n    ", "\n    /* stylelint-disable-next-line scale-unlimited/declaration-strict-value */\n    font-size: ", ";\n    font-family: ", ";\n    cursor: pointer;\n    transition-duration: ", ";\n    transition-property: color;\n    appearance: none;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var linkBaseStyles = /*#__PURE__*/css( /*#__PURE__*/_templateObject(), focusRing, function (_ref) {
  var inherit = _ref.inherit;
  return inherit ? 'inherit' : fontMedium;
}, fontDefault, smooth);
var linkColor = /*#__PURE__*/css( /*#__PURE__*/_templateObject2(), pink800, pink800, pink600);

function _templateObject14() {
  var data = _taggedTemplateLiteralLoose(["\n    ", "\n    margin: 0;\n    padding: 0;\n    color: inherit;\n    font-size: inherit;\n    font-family: inherit;\n    background: none;\n    border: none;\n    cursor: pointer;\n"]);

  _templateObject14 = function _templateObject14() {
    return data;
  };

  return data;
}

function _templateObject13() {
  var data = _taggedTemplateLiteralLoose(["\n    position: absolute;\n"]);

  _templateObject13 = function _templateObject13() {
    return data;
  };

  return data;
}

function _templateObject12() {
  var data = _taggedTemplateLiteralLoose(["\n    visibility: hidden;\n"]);

  _templateObject12 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = _taggedTemplateLiteralLoose(["\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    padding: 0;\n    ", "\n    ", ";\n    background: none;\n    border: none;\n\n    &:disabled {\n        ", ";\n    }\n"]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteralLoose(["\n    ", "\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    box-sizing: border-box;\n    padding: ", " ", ";\n    font-size: ", ";\n    font-family: ", ";\n    line-height: ", ";\n    white-space: nowrap;\n    border: none;\n    border-radius: ", ";\n    cursor: pointer;\n    transition-duration: ", ";\n    transition-property: background, border, color;\n    appearance: none;\n    ", ";\n    ", ";\n\n    &:disabled {\n        ", ";\n    }\n"]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteralLoose(["\n    color: ", ";\n\n    &:hover,\n    &:active {\n        color: ", ";\n    }\n"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteralLoose(["\n    color: ", ";\n    cursor: not-allowed;\n\n    &:hover,\n    &:active {\n        color: ", ";\n    }\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteralLoose(["\n        min-height: 40px;\n        border-radius: ", ";\n\n        [data-telescope-icon] {\n            width: 18px;\n            height: 18px;\n        }\n    "]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteralLoose(["\n            width: 48px;\n            height: 48px;\n            padding: 0;\n            border-radius: ", ";\n\n            [data-telescope-icon] {\n                width: 20px;\n                height: 20px;\n            }\n        "]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteralLoose(["\n    ", "\n    border: none;\n    box-shadow: ", ";\n    transition-timing-function: ease-in-out;\n    transition-duration: ", ";\n    transition-property: box-shadow;\n\n    &:hover,\n    &:focus,\n    &:active {\n        background-color: ", ";\n    }\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteralLoose(["\n    color: ", ";\n    background-color: ", ";\n    border: 3px solid transparent;\n\n    &:hover,\n    &:focus,\n    &:active {\n        color: ", ";\n        background-color: ", ";\n        border-color: ", ";\n    }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["\n    color: ", ";\n    background-color: ", ";\n    border: 3px solid ", ";\n\n    &:hover,\n    &:focus,\n    &:active {\n        color: ", ";\n        border-color: ", ";\n    }\n\n    &:focus {\n        border-color: ", ";\n    }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$1() {
  var data = _taggedTemplateLiteralLoose(["\n    color: ", ";\n    background-color: ", ";\n\n    &:hover,\n    &:focus,\n    &:active {\n        color: ", ";\n        background-color: ", ";\n    }\n"]);

  _templateObject2$1 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$1() {
  var data = _taggedTemplateLiteralLoose(["\n    color: ", ";\n    background-color: ", ";\n    border: none;\n    cursor: not-allowed;\n\n    &:hover,\n    &:focus,\n    &:active {\n        color: ", ";\n    }\n"]);

  _templateObject$1 = function _templateObject() {
    return data;
  };

  return data;
}

var disabledButtonStyles = /*#__PURE__*/css( /*#__PURE__*/_templateObject$1(), shade500, shade300, shade500);
var primaryButtonStyles = /*#__PURE__*/css( /*#__PURE__*/_templateObject2$1(), shade000, shade800, shade000, shade900);
var secondaryButtonStyles = /*#__PURE__*/css( /*#__PURE__*/_templateObject3(), shade600, shade000, shade400, shade600, shade500, shade400);
var ghostButtonStyles = /*#__PURE__*/css( /*#__PURE__*/_templateObject4(), shade600, shade000, shade700, shade200, shade200);
var raisedButtonStyles = /*#__PURE__*/css( /*#__PURE__*/_templateObject5(), secondaryButtonStyles, shadowElevateStrong, smooth, shade100);

var getVariantStyles = function getVariantStyles(props) {
  if (props.disabled) {
    return disabledButtonStyles;
  } else if (props.variant === 'primary') {
    return primaryButtonStyles;
  } else if (props.variant === 'secondary') {
    return secondaryButtonStyles;
  } else if (props.variant === 'raised') {
    return raisedButtonStyles;
  } else if (props.variant === 'ghost') {
    return ghostButtonStyles;
  }

  return primaryButtonStyles;
};

var getRoundedStyles = function getRoundedStyles(props) {
  if (props.rounded) {
    return css(_templateObject6(), circle);
  }

  return css(_templateObject7(), arc99999);
};

var disabledButtonLinkStyles = /*#__PURE__*/css( /*#__PURE__*/_templateObject8(), shade400, shade400);
var secondaryButtonLinkStyles = /*#__PURE__*/css( /*#__PURE__*/_templateObject9(), shade600, shade700);

var getColorStyles = function getColorStyles(props) {
  if (props.disabled) {
    return disabledButtonLinkStyles;
  } else if (props.variant === 'link') {
    return linkColor;
  } else if (props.variant === 'link-secondary') {
    return secondaryButtonLinkStyles;
  }

  return linkColor;
};

var BaseButton = /*#__PURE__*/styled.button.withConfig({
  shouldForwardProp: function shouldForwardProp(prop, defaultValidatorFn) {
    return !['loading'].includes(prop) && defaultValidatorFn(prop);
  }
})( /*#__PURE__*/_templateObject10(), focusRing, spacing8, spacing32, fontMedium, fontDefault, lineHeight1, function (props) {
  return props.rounded ? circle : arc99999;
}, smooth, getVariantStyles, getRoundedStyles, disabledButtonStyles);
var ButtonLink = /*#__PURE__*/styled.button( /*#__PURE__*/_templateObject11(), linkBaseStyles, getColorStyles, disabledButtonLinkStyles);
var Hidden = /*#__PURE__*/styled.span( /*#__PURE__*/_templateObject12());
var ButtonLoading = /*#__PURE__*/styled(Loading)( /*#__PURE__*/_templateObject13());
var NakedButton = /*#__PURE__*/styled.button( /*#__PURE__*/_templateObject14(), focusRing);

function _templateObject$2() {
  var data = _taggedTemplateLiteralLoose([""]);

  _templateObject$2 = function _templateObject() {
    return data;
  };

  return data;
}

var getBaseComponent = function getBaseComponent(props) {
  if (props.disabled) {
    // Anchor tags cannot be disabled so output a button when this prop is set to true
    return 'button';
  } else if (props.as) {
    return props.as;
  } else if (props.href) {
    return 'a';
  }

  return 'button';
};

var getLabelFromChildren = function getLabelFromChildren(children) {
  var label = '';
  React.Children.map(children, function (child) {
    if (typeof child === 'string') {
      label += child;
    }
  });
  return label;
};

var Button = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var children = _ref.children,
      props = _objectWithoutPropertiesLoose(_ref, ["children"]);

  if (props.loading) {
    return React.createElement(BaseButton, Object.assign({
      type: 'button',
      as: getBaseComponent(props),
      disabled: true,
      "aria-label": getLabelFromChildren(children),
      ref: ref
    }, props, {
      "data-telescope-button": true
    }), React.createElement(Hidden, null, children), React.createElement(ButtonLoading, {
      size: 8
    }));
  }

  if (props.variant === 'link' || props.variant === 'link-secondary') {
    return React.createElement(ButtonLink, Object.assign({}, props, {
      as: getBaseComponent(props),
      ref: ref,
      "data-telescope-button": true
    }), children);
  }

  return React.createElement(BaseButton, Object.assign({
    type: 'button'
  }, props, {
    as: getBaseComponent(props),
    ref: ref,
    "data-telescope-button": true
  }), children);
});
var NakedButton$1 = NakedButton;
var ButtonGroup = /*#__PURE__*/styled(Inline).attrs({
  space: 16,
  alignY: 'center'
})( /*#__PURE__*/_templateObject$2());

function _templateObject$3() {
  var data = _taggedTemplateLiteralLoose(["\n    ", "\n    ", "\n"]);

  _templateObject$3 = function _templateObject() {
    return data;
  };

  return data;
}

var Link = /*#__PURE__*/styled.a.attrs({
  'data-telescope-link': true
})( /*#__PURE__*/_templateObject$3(), linkBaseStyles, linkColor);
export { Button, ButtonGroup, Link, NakedButton$1 as NakedButton, getLabelFromChildren };